

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface LabTestMethodParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
  
}

export interface LabTestMethod {
    id?: string;
    name: string;
    isActive: string;
    parameters?: LabTestMethodParameter[];
    links?: any;
}

export abstract class LabTestMethodData {
  //abstract fireRequest(data: Department, method: string): Observable<any>;
  abstract list(url: string): Observable<LabTestMethod[]>;
  abstract create(url: string,data: LabTestMethod): Observable<any>;
  abstract update(url: string,data: LabTestMethod): Observable<any>;
  abstract delete(url: string): Observable<any>;
}
